module.exports = {
	"header": "E-mails & Linked accounts",
	"addEmail": "Add e-mail",
	"addSecondaryEmail": "Add a secondary e-mail address",
	"enterEmail": "Enter e-mail",
	"email": "Primary e-mail",
	"organizationEmail": "E-mail",
	"emailRemoved": "E-mail successfully removed.",
	"emailsLinkedAccountsText": {
		"part1": "These logins grant access to your account.",
		"part2": "You can log in with any Google or Facebook account using these e-mails."
	},
	"emailUnconfirmed": "Unconfirmed",
	"emailYesDelete": "Yes, delete this e-mail address",
	"organizationAccessInviteButton": "Get access to the seller account.",
	"organizationAccessInviteContent": "You have been invited to access __sellerName__ seller account.",
	"organizationAccessNoAccount": "However it appears that you don't have an __brand__ account. Once registered, you will automatically have access to the __name__ seller account.",
	"confirmEmail": {
		"emailContent": "You have claimed the ownership of this e-mail address for your __brand__ account. We need to confirm the validity of your address.",
		"emailSent": "Confirmation e-mail sent to __emailAddress__.",
		"emailSubject": "E-mail address validation",
		"emailAfterButton": "If you haven't requested a validation, simply ignore this e-mail.",
		"emailButton": "Confirm my ownership of this e-mail address.",
		"linkNotValid": "This e-mail address validation link is invalid or has expired.",
		"success": "E-mail address confirmed."
	},
	"forgotPw": {
		"emailContent": "You have requested a password reset.",
		"emailAfterButton": "If you haven't requested a password reset, simply ignore this e-mail.",
		"emailSubject": "Password reset"
	},
	"removeConfirmation": "Are you sure you want to remove <email /> from your e-mail addresses?",
	"resendConfirmationEmail": "Resend confirmation e-mail",
	"sendError": "Error sending e-mail to: __emailAddress__",
	"cantAddSecondaryEmail": "You can't add a secondary e-mail address until you have confirmed your primary e-mail.",
	"successfullyAdded": "Successfully added new e-mail",
	"successfullyRemoved": "Successfully removed e-mail",
	"unconfirmedWarning": "There is already an unconfirmed e-mail address attached to this account, adding another one will override the existing one.",
	"userList": {
		"emailAddedSubject": "Access to __organization__",
		"emailAddedContent": "You have been given access to __organization__. You can login on __brand__ to bid now or create an account if you don't have one."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/email.json5
// module id = 1927
// module chunks = 6